<div class="main-div">
  <div class="modal-header modalHeaderBlack">
    <h6 class="modal-title">Change Provider</h6>
    <mat-icon matTooltip="Close" (click)="onClose()">clear</mat-icon>
  </div>
  <form [formGroup]="changeProvide">
  <mat-grid-list cols="10" rowHeight="50px">
    <mat-grid-tile [colspan]="7"></mat-grid-tile>
    <mat-grid-tile [colspan]="3">
      <mat-checkbox (change)="toggleDepartmentVisit($event)">
        {{ "EncounterPage.departmentVisit" | translate }}
      </mat-checkbox>
    </mat-grid-tile>
  </mat-grid-list>
  <mat-grid-list cols="10" rowHeight="70px" style="margin: 5px">
    <mat-grid-tile [colspan]="5">
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>{{ "EncounterPage.encounterType" | translate }}</mat-label>
        <mat-select [required]="true" 
        formControlName="encounterType">
          <mat-option>
            <ngx-mat-select-search
            [formControl]="encounterTypeSearchCtrl"
              [placeholderLabel]="'Search'"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option>{{ "RegistrationPage.none" | translate }}</mat-option>
          <mat-option
            *ngFor="let option of encounterTypeFilterList"
            [value]="option"
          >
            {{ option.desc }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="5">
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>{{ "EncounterPage.speciality" | translate }}</mat-label>
        <mat-select [required]="true" (selectionChange)="getDoctorList($event)"
         formControlName="speciality">
          <mat-option>
            <ngx-mat-select-search
            [formControl]="specialitySearchCtrl"
              [placeholderLabel]="'Search'"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option>{{ "RegistrationPage.none" | translate }}</mat-option>
          <mat-option
            *ngFor="let option of specialityFilterList"
            [value]="option"
          >
            {{ option.desc }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>
  <mat-grid-list cols="10" rowHeight="60px" style="margin: 5px">
    <mat-grid-tile [colspan]="5">
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>{{ "EncounterPage.doctor" | translate }}</mat-label>
        <mat-select [required]="!isDepartmentVisit"
          formControlName="doctor">
          <mat-option>
            <ngx-mat-select-search
            [formControl]="doctorSearchCtrl"
              [placeholderLabel]="'Search'"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option>{{ "RegistrationPage.none" | translate }}</mat-option>
          <mat-option *ngFor="let option of doctorFilterList" [value]="option">
            {{ option.desc }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="5">
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>{{ "EncounterPage.clinic" | translate }}</mat-label>
        <mat-select
        formControlName="clinic">
          <mat-option>
            <ngx-mat-select-search
            [formControl]="clinicSearchCtrl"
              [placeholderLabel]="'Search'"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option>{{ "RegistrationPage.none" | translate }}</mat-option>
          <mat-option *ngFor="let option of clinicFilterList" [value]="option">
            {{ option.desc }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>
  <mat-grid-list cols="10" rowHeight="60px" style="margin: 5px">
    <mat-grid-tile [colspan]="10">
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>{{ "billing.reason" | translate }}</mat-label>
        <mat-select [required]="true"   formControlName="reason">
          <mat-option>
            <ngx-mat-select-search
            [formControl]="reasonSearchCtrl"
              [placeholderLabel]="'Search'"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option>{{ "RegistrationPage.none" | translate }}</mat-option>
          <mat-option *ngFor="let option of reasonfilterList" [value]="option">
            {{ option.desc }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>
  <mat-grid-list cols="10" rowHeight="75px" style="margin: 5px">
    <mat-grid-tile [colspan]="10">
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Remark</mat-label>
        <textarea
         formControlName="remark"
          attr.data-automation-attribute="encounterRemark"
          matInput
          pattern="[a-zA-Z0-9\s]+"
        ></textarea>
      </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>
</form>
  <div class="modal-footer modalFooterConfirmDialog">
    <div>
      <button mat-mini-fab class="btnBlue" matTooltip="Back" (click)="onClose()">
        <mat-icon >keyboard_arrow_left</mat-icon>
      </button>
      &nbsp;
      <button mat-mini-fab class="btnCyan"  matTooltip="Save" (click)="Submit()">
        <mat-icon>sim_card</mat-icon>
      </button>
    </div>
  </div>
</div>
